import { Box } from "@mui/material";
import WinWire from "./WinWire";
import Reports from "./Reports";
import Insights from "./Insights";

const ContentContainer = ({ selectedChannel, content, user, isMobileDisplay, scrollToBottom }) => {
  if (!selectedChannel) return null;
  return (
    <Box
      className="hub-content-window-container"
      sx={{
        borderRadius: isMobileDisplay ? "0.75rem 0.75rem 0 0" : "0 0.75rem 0.75rem 0",
        flexGrow: 1,
      }}
    >
      {selectedChannel.key === "win-wire" && (
        <WinWire
          isMobileDisplay={isMobileDisplay}
          messages={content.winWire}
          user={user}
          scrollToBottom={scrollToBottom}
        />
      )}
      {selectedChannel.key === "reports" && (
        <Reports
          isMobileDisplay={isMobileDisplay}
          reports={content.reports}
          user={user}
          scrollToBottom={scrollToBottom}
        />
      )}
      {selectedChannel.key === "insights" && (
        <Insights
          isMobileDisplay={isMobileDisplay}
          insights={content.insights}
          user={user}
          scrollToBottom={scrollToBottom}
        />
      )}
    </Box>
  );
};
export default ContentContainer;
